module.exports = new __parcel__URL__("facebook.487cb853.svg").toString();